import { render, staticRenderFns } from "./IconTick.vue?vue&type=template&id=4b6cbd3a&"
import script from "./IconTick.vue?vue&type=script&lang=js&"
export * from "./IconTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6cbd3a')) {
      api.createRecord('4b6cbd3a', component.options)
    } else {
      api.reload('4b6cbd3a', component.options)
    }
    module.hot.accept("./IconTick.vue?vue&type=template&id=4b6cbd3a&", function () {
      api.rerender('4b6cbd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTick.vue"
export default component.exports